import React from 'react';

type ProviderWithProps = {
  props?: Record<string, any>;
  provider: React.JSXElementConstructor<any>;
};

type ProviderComposerProps = {
  children: React.ReactNode;
  providers: ProviderWithProps[];
};

/**
 * Composes multiple providers into a single component.
 * For example: `<QueryProvider><ThemeProvider><AuthProvider>`
 * children
 * `</AuthProvider></ThemeProvider></QueryProvider>`
 */
export const ProviderComposer = ({
  children,
  providers,
}: ProviderComposerProps) =>
  providers.reduceRight<React.ReactElement | null>(
    (acc, { props = {}, provider: Provider }) => (
      <Provider {...props}>{acc}</Provider>
    ),
    children as React.ReactElement | null
  );
